import { createAction } from 'redux-act';
// add Shift action
const addShiftRequest = createAction('ADD_SHIFT_REQUEST', data => data);
const addShiftSuccess = createAction('ADD_SHIFT_SUCCESS', data => data);
const addShiftError = createAction('ADD_SHIFT_ERROR');

// get Shift action
const getAllShiftRequest = createAction('GET_ALL_SHIFT_REQUEST', data => data);
const getAllShiftSuccess = createAction('GET_ALL_SHIFT_SUCCESS', data => data);
const getAllShiftError = createAction('GET_ALL_SHIFT_ERROR');

//Get Shift By Id
const getShiftByIdRequest = createAction('GET_SHIFT_BY_ID_REQUEST', data => data);
const getShiftByIdSuccess = createAction('GET_SHIFT_BY_ID_SUCCESS', data => data);
const getShiftByIdError = createAction('GET_SHIFT_BY_ID_ERROR');

// Update Shift action
const updateShiftRequest = createAction('UPDATE_SHIFT_REQUEST', data => data);
const updateShiftSuccess = createAction('UPDATE_SHIFT_SUCCESS', data => data);
const updateShiftError = createAction('UPDATE_SHIFT_ERROR');

// Delete Shift action
const deleteShiftRequest = createAction('DELETE_SHIFT_REQUEST', data => data);
const deleteShiftSuccess = createAction('DELETE_SHIFT_SUCCESS', data => data);
const deleteShiftError = createAction('DELETE_SHIFT_ERROR');

const addShiftConfigurationRequest = createAction('ADD_SHIFT_CONFIGURATION_REQUEST', data => data);
const addShiftConfigurationSuccess = createAction('ADD_SHIFT_CONFIGURATION_SUCCESS', data => data);
const addShiftConfigurationError = createAction('ADD_SHIFT_CONFIGURATION_ERROR');

// get Shift Configuration
// const getShiftConfigurationRequest = createAction('GET_ALL_SHIFT_CONFIGURATION_REQUEST', data => data);
// const getShiftConfigurationSuccess = createAction('GET_ALL_SHIFT_CONFIGURATION_SUCCESS', data => data);
// const getShiftConfigurationError = createAction('GET_ALL_SHIFT_CONFIGURATION_ERROR');

// add Shift Calendar
const addShiftCalendarRequest = createAction('ADD_SHIFT_CALENDAR_REQUEST', data => data);
const addShiftCalendarSuccess = createAction('ADD_SHIFT_CALENDAR_SUCCESS', data => data);
const addShiftCalendarError = createAction('ADD_SHIFT_CALENDAR__ERROR');

// get Shift Calendar
const getAllShiftCalendarRequest = createAction('GET_ALL_SHIFT_CALENDAR_REQUEST', data => data);
const getAllShiftCalendarSuccess = createAction('GET_ALL_SHIFT_CALENDAR_SUCCESS', data => data);
const getAllShiftCalendarError = createAction('GET_ALL_SHIFT_CALENDAR_ERROR');


// Update Shift Calendar
const updateShiftCalendarRequest = createAction('UPDATE_SHIFT_CALENDAR_REQUEST', data => data);
const updateShiftCalendarSuccess = createAction('UPDATE_SHIFT_CALENDAR_SUCCESS', data => data);
const updateShiftCalendarError = createAction('UPDATE_SHIFT_CALENDAR_ERROR');

// Delete Shift Calendar
const deleteShiftCalendarRequest = createAction('DELETE_SHIFT_CALENDAR_REQUEST', data => data);
const deleteShiftCalendarSuccess = createAction('DELETE_SHIFT_CALENDAR_SUCCESS', data => data);
const deleteShiftCalendarError = createAction('DELETE_SHIFT_CALENDAR_ERROR');

// Assign shift
const assignShiftRequest = createAction('ASSIGN_SHIFT_REQUEST', data => data);
const assignShiftSuccess = createAction('ASSIGN_SHIFT_SUCCESS', data => data);
const assignShiftError = createAction('ASSIGN_SHIFT_ERROR');

// Add Week Off
const addWeekOffRequest = createAction('ADD_WEEK_OFF_REQUEST', data => data);
const addWeekOffSuccess = createAction('ADD_WEEK_OFF_SUCCESS', data => data);
const addWeekOffError = createAction('ADD_WEEK_OFF_ERROR');

// Get Employee by shift
const getEmployeeByShiftIdRequest = createAction('GET_EMPLOYEE_BY_SHIFT_REQUEST', data => data);
const getEmployeeByShiftIdSuccess = createAction('GET_EMPLOYEE_BY_SHIFT_SUCCESS', data => data);
const getEmployeeByShiftIdError = createAction('GET_EMPLOYEE_BY_SHIFT_ERROR');

// Get All Shift Details
const getAllShiftDetailsRequest = createAction('GET_ALL_SHIFT_DETAILS_REQUEST', data => data);
const getAllShiftDetailsSuccess = createAction('GET_ALL_SHIFT_DETAILS_SUCCESS', data => data);
const getAllShiftDetailsError = createAction('GET_ALL_SHIFT_DETAILS_ERROR');

// Delete emplyoee shift
const deleteEmployeeShiftRequest = createAction('DELETE_EMPLOYEE_SHIFT_REQUEST', data => data);
const deleteEmployeeShiftSuccess = createAction('DELETE_EMPLOYEE_SHIFT_SUCCESS', data => data);
const deleteEmployeeShiftError = createAction('DELETE_EMPLOYEE_SHIFT_ERROR');

// active or inactive shift
const activeOrInactiveRequest = createAction('ACTIVE_OR_INACTIVE_REQUEST', data => data);
const activeOrInactiveSuccess = createAction('ACTIVE_OR_INACTIVE_SUCCESS', data => data);
const activeOrInactiveError = createAction('ACTIVE_OR_INACTIVE_ERROR');

// get Employee Shift Details By id 
const getEmployeeShiftDetailsByIdRequest = createAction('GET_EMPLOYEE_SHIFT_DETAILS_REQUEST', data => data);
const getEmployeeShiftDetailsByIdSuccess = createAction('GET_EMPLOYEE_SHIFT_DETAILS_SUCCESS', data => data);
const getEmployeeShiftDetailsByIdError = createAction('GET_EMPLOYEE_SHIFT_DETAILS_ERROR');

// clear existing Shift action
const handleClearShiftStore = createAction('HANDLE_CLEAR_SHIFT_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addShiftRequest,
    addShiftSuccess,
    addShiftError,

    getAllShiftRequest,
    getAllShiftSuccess,
    getAllShiftError,

    updateShiftRequest,
    updateShiftSuccess,
    updateShiftError,

    deleteShiftRequest,
    deleteShiftSuccess,
    deleteShiftError,

    addShiftConfigurationRequest,
    addShiftConfigurationSuccess,
    addShiftConfigurationError,

    // getShiftConfigurationRequest,
    // getShiftConfigurationSuccess,
    // getShiftConfigurationError,

    addShiftCalendarRequest,
    addShiftCalendarSuccess,
    addShiftCalendarError,

    getAllShiftCalendarRequest,
    getAllShiftCalendarSuccess,
    getAllShiftCalendarError,

    updateShiftCalendarRequest,
    updateShiftCalendarSuccess,
    updateShiftCalendarError,

    deleteShiftCalendarRequest,
    deleteShiftCalendarSuccess,
    deleteShiftCalendarError,

    getShiftByIdRequest,
    getShiftByIdSuccess,
    getShiftByIdError,

    assignShiftRequest,
    assignShiftSuccess,
    assignShiftError,

    addWeekOffRequest,
    addWeekOffSuccess,
    addWeekOffError,

    getEmployeeByShiftIdRequest,
    getEmployeeByShiftIdSuccess,
    getEmployeeByShiftIdError,

    getAllShiftDetailsRequest,
    getAllShiftDetailsSuccess,
    getAllShiftDetailsError,

    deleteEmployeeShiftRequest,
    deleteEmployeeShiftSuccess,
    deleteEmployeeShiftError,

    activeOrInactiveRequest,
    activeOrInactiveSuccess,
    activeOrInactiveError,

    getEmployeeShiftDetailsByIdRequest,
    getEmployeeShiftDetailsByIdSuccess,
    getEmployeeShiftDetailsByIdError,

    handleClearShiftStore,
    // toastMsgAction,
    
}